<div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title">User Profile</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeOffcanvas.dismiss()"></button>
</div>
<div class="offcanvas-body">
    @if (me) {
        <div class="d-flex flex-column align-items-center mb-4">
            <div class="avatar-circle mb-3">
                <span class="initials">{{ getInitials() }}</span>
            </div>
            <h5 class="mb-1">{{ me.firstName }} {{ me.lastName }}</h5>
            <p class="text-body-secondary mb-0">{{ me.emailAddress }}</p>
        </div>

        <ul ngbNav #nav="ngbNav" class="nav-pills">
            <li ngbNavItem>
                <button ngbNavLink>My Details</button>
                <ng-template ngbNavContent>
                    <div class="user-details mt-2">
                        <div class="detail-item">
                            <fa-icon [icon]="['fas', 'user']" class="me-2 text-body-secondary"></fa-icon>
                            <span class="label">Username:</span>
                            <span class="value">{{ me.username }}</span>
                        </div>
                        <div class="detail-item">
                            <fa-icon [icon]="['fas', 'hashtag']" class="me-2 text-body-secondary"></fa-icon>
                            <span class="label">Id:</span>
                            <span class="value">{{ me.id }} - {{ me.auth0Id }}</span>
                        </div>
                        <div class="detail-item">
                            <fa-icon [icon]="['fas', 'envelope']" class="me-2 text-body-secondary"></fa-icon>
                            <span class="label">Email:</span>
                            <span class="value">{{ me.emailAddress }}</span>
                        </div>

                        @if (me.isSupport) {
                            <div class="detail-item">
                                <fa-icon [icon]="['fas', 'headset']" class="me-2 text-body-secondary"></fa-icon>
                                <span class="badge bg-info">Support</span>
                            </div>
                        }

                        @if (me.isAdmin) {
                            <div class="detail-item">
                                <fa-icon [icon]="['fas', 'shield']" class="me-2 text-body-secondary"></fa-icon>
                                <span class="badge bg-primary">Administrator</span>
                            </div>
                        }

                        <strong>Roles:</strong>

                        @for (role of me.roles; track role) {
                            <div class="detail-item">
                                <fa-icon [icon]="['fas', 'user-tag']" class="me-2 text-body-secondary"></fa-icon>
                                <span class="badge bg-secondary">{{ role }}</span>
                            </div>
                        }
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <button ngbNavLink>Notifications</button>
                <ng-template ngbNavContent>
                    @for (n of me.notifications; track n) {
                        <div class="p-3 border rounded bg-light mt-3">
                            <h6 class="mb-2">{{ n.name }}</h6>

                            <form #form="ngForm">
                                <div class="form-check form-check-inline">
                                    <input
                                        [(ngModel)]="n.emailEnabled"
                                        name="emailEnabled-{{ n.notificationTypeId }}"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="emailEnabled-{{ n.notificationTypeId }}" />
                                    <label class="form-check-label" for="emailEnabled-{{ n.notificationTypeId }}"
                                        >Email</label
                                    >
                                </div>
                                <div class="form-check form-check-inline">
                                    <input
                                        [(ngModel)]="n.smsEnabled"
                                        name="smsEnabled-{{ n.notificationTypeId }}"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="smsEnabled-{{ n.notificationTypeId }}" />
                                    <label class="form-check-label" for="smsEnabled-{{ n.notificationTypeId }}"
                                        >SMS</label
                                    >
                                </div>
                            </form>
                        </div>
                    }

                    <div class="d-grid mt-4">
                        <button
                            sqButton
                            size="md"
                            color="success"
                            icon="save"
                            [isLoading]="isSaving()"
                            (click)="updateNotificationPreferences(me?.notifications || [])">
                            Save
                        </button>
                    </div>
                </ng-template>
            </li>

            @if (company?.enableAnalytics !== false) {
                <!-- ^^ Don't bother showing this tab if analytics is disabled at the company level -->
                <li ngbNavItem>
                    <button ngbNavLink>Privacy</button>
                    <ng-template ngbNavContent>
                        <div class="privacy-section mt-2">
                            <div class="p-3 border rounded bg-light mt-3">
                                <h5>Privacy and Analytics</h5>
                                <p>
                                    We collect information such as feature usage, navigation and interaction events. We
                                    don't collect the contents of your quotes, customer communications or other
                                    sensitive information for analytics purposes.
                                </p>
                                <div class="form-check">
                                    <input
                                        [(ngModel)]="me.enableAnalytics"
                                        (ngModelChange)="onEnableAnalyticsChange($event)"
                                        name="enableAnalytics"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="enableAnalytics" />
                                    <label class="form-check-label" for="enableAnalytics">Enable Analytics</label>
                                </div>
                                @if (company?.enableSessionReplay !== false) {
                                    <div class="form-check">
                                        <input
                                            [(ngModel)]="me.enableSessionReplay"
                                            [disabled]="me.enableAnalytics === false"
                                            name="enableSessionReplay"
                                            class="form-check-input"
                                            type="checkbox"
                                            id="enableSessionReplay" />
                                        <label class="form-check-label" for="enableSessionReplay"
                                            >Enable Session Replay</label
                                        >
                                    </div>
                                }
                                <div class="d-grid mt-4">
                                    <button
                                        sqButton
                                        size="md"
                                        color="success"
                                        icon="save"
                                        [isLoading]="isSavingPrivacy()"
                                        (click)="
                                            updatePrivacyPreferences(
                                                me?.enableAnalytics || false,
                                                me?.enableSessionReplay || false
                                            )
                                        ">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
            }
        </ul>
        <div [ngbNavOutlet]="nav"></div>
    }
</div>
<div class="offcanvas-footer border-top mt-auto p-3">
    <button sqButton color="danger" class="w-100" (click)="logout()">
        <fa-icon [icon]="['fas', 'sign-out-alt']" class="me-2"></fa-icon>
        Sign Out
    </button>
</div>
